<template>
  <div
    v-on="$listeners"
    :class="[
      'dropdown-item',
      {
        'dropdown-item--title': isGroupTitle,
        'disabled': disabled,
        'active': isActive
      }
    ]"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'DropdownItem',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isGroupTitle: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
